/**
 * Label row for a form control: the <label> plus a red asterisk when the field
 * is mandatory. The asterisk sits outside the <label> and is hidden from
 * assistive tech (the control carries aria-required), so the field's accessible
 * name stays exactly the label text.
 */
export function FieldLabel({ htmlFor, children, required = false }) {
  return (
    <span className="flex items-baseline">
      <label htmlFor={htmlFor} className="text-sm font-medium">
        {children}
      </label>
      {required && (
        <span aria-hidden="true" className="ml-0.5 text-red-600 dark:text-red-400">
          *
        </span>
      )}
    </span>
  );
}
